import { render } from "./certificates.vue?vue&type=template&id=7fa5a4a7&scoped=true"
import script from "./certificates.vue?vue&type=script&lang=js"
export * from "./certificates.vue?vue&type=script&lang=js"

import "./certificates.vue?vue&type=style&index=0&id=7fa5a4a7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa5a4a7"]])

export default __exports__